import { useQuery } from '@apollo/client';
import { createError } from '@common/neo.tax';

import { GetAccountingExpenseQuery, GetAccountingExpenseQueryVariables, GET_ACCOUNTING_EXPENSE } from '@neo.tax/shared';

export type AccountingExpense = GetAccountingExpenseQuery['getAccountingExpense'];

export const useAccountingExpense = (
  accountingExpenseId: string,
  options?: { skip: boolean },
):
  | {
      accountingExpense: null;
      loading: true;
    }
  | {
      accountingExpense: AccountingExpense | null;
      loading: false;
    } => {
  const { data, error, loading } = useQuery<GetAccountingExpenseQuery, GetAccountingExpenseQueryVariables>(
    GET_ACCOUNTING_EXPENSE,
    options?.skip ? { skip: true } : { variables: { accountingExpenseId } },
  );

  if (loading) {
    return { accountingExpense: null, loading: true };
  }
  if (error) {
    throw error;
  }
  if (options?.skip) {
    return { accountingExpense: null, loading: false };
  }
  if (!data) {
    throw createError('MissingAccountingExpense', `Failed to load AccountingExpense with id ${accountingExpenseId}`);
  }

  return {
    accountingExpense: data.getAccountingExpense,
    loading,
  };
};
